
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  --transition-time:0.3s;
  --easing:cubic-bezier(0.86, 0, 0.07, 1);
  --popover-btn-scale:1 + (10 / 30);
  --popover-btn-large-scale:1 + (10 / 40);
}

.show-for-sr{
  clip:rect(1px, 1px, 1px, 1px);
  height:1px;
  overflow:hidden;
  position:absolute !important;
  white-space:nowrap;
  width:1px;
}

.popover{
  left:0;
  position:absolute;
  top:0;
  transition:all var(--transition-time);
  z-index:10;
  display:none;
}

@media (min-width: 1024px){

.popover{
    display:block
}
  }

.popover__container{
    background-color:var(--brand-dark-blue);
    border-radius:20px;
    height:268px;
    position:absolute;
    transition:all var(--transition-time) var(--easing);
    width:418px;
    left:-388px;
    padding:32px;
    top:calc(-268px + 30px);
  }

.popover__container--alt:not(.popover--is-hidden) .popover__container{
      background-color:var(--brand-light-blue);
      height:324px;
      padding:50px;
    }

.our-states .popover__container--alt:not(.popover--is-hidden) .popover__container{
        top:calc(-324px + 30px);
      }

.interactive-document .popover__container{
      left:-378px;
      top:calc(-268px + 40px);
    }

.popover__content{
    height:100%;
    transition:all var(--transition-time) var(--transition-time);
  }

.popover__heading,
  .popover__desc{
    color:var(--outline-white);
  }

.popover__heading--alt .popover__heading, .popover__desc--alt .popover__desc{
      color:var(--brand-dark-blue);
    }

.popover__heading{
    font-size:32px;
    font-family:var(--ff-bold);
    line-height:calc(40 / 32);
  }

.popover__heading,
    .user-markup .popover__heading{
      margin-bottom:calc(16px - 6px);
      margin-top:-6px;
    }

.popover__desc{
    font-size:18px;
    font-family:var(--ff-body);
    line-height:calc(27 / 18);
    margin-bottom:8px;
  }

.popover .popover-btn{
    left:0;
    position:absolute;
    top:0;
  }

.popover--large__heading{
      font-size:24px;
      line-height:calc(32 / 24);
    }

.popover--large--is-hidden__container{
        height:40px;
        width:40px;
      }

.popover--is-hidden{
    transition:all var(--transition-time) var(--transition-time);
    z-index:1;
  }

.md-no-js .popover--is-hidden{
      z-index:10;
    }

.popover--is-hidden .popover__container{
      background-color:rgba(var(--brand-dark-blue), 0);
      border-radius:50%;
      height:30px;
      left:0;
      overflow:hidden;
      padding:0;
      pointer-events:none;
      top:0;
      transition:all var(--transition-time) var(--easing);
      width:30px;
    }

.md-no-js .popover--is-hidden .popover__container{
        background-color:var(--brand-dark-blue);
        border-radius:20px;
        height:268px;
        left:-388px;
        padding:40px;
        top:-228px;
        width:418px;
      }

.popover--is-hidden .popover__content{
      opacity:0;
      transition:all 0s;
      visibility:hidden;
    }

.md-no-js .popover--is-hidden .popover__content{
        opacity:1;
        visibility:visible;
      }

.popover--reverse__container{
      left:0;
    }

.popover--service-address{
    left:calc(270 / 837 * 100%);
    top:calc(18 / 415 * 100%);
  }

.popover--account-number{
    left:calc(552 / 837 * 100%);
    top:calc(18 / 415 * 100%);
  }

.popover--contact{
    left:calc(32 / 837 * 100%);
    top:calc(77 / 415 * 100%);
  }

.popover--usage-data{
    left:calc(32 / 837 * 100%);
    top:calc(146 / 415 * 100%);
  }

.popover--bill-calculation{
    left:calc(32 / 837 * 100%);
    top:calc(228 / 415 * 100%);
  }

.popover--history-chart{
    left:calc(455 / 837 * 100%);
    top:calc(228 / 415 * 100%);
  }

.popover--due-date{
    left:calc(32 / 837 * 100%);
    top:calc(365 / 415 * 100%);
  }

.popover--illinois{
    left:calc(515 / 839 * 100%);
    top:calc(206 / 519 * 100%);
  }

@media (min-width: 1280px){

.popover--illinois{
      left:calc(692 / 1118 * 100%);
      top:calc(284 / 691 * 100%)
  }
    }

.popover--indiana{
    left:calc(563 / 839 * 100%);
    top:calc(207 / 519 * 100%);
  }

@media (min-width: 1280px){

.popover--indiana{
      left:calc(756 / 1118 * 100%);
      top:calc(284 / 691 * 100%)
  }
    }

.popover--new-jersey{
    left:calc(736 / 839 * 100%);
    top:calc(175 / 519 * 100%);
  }

@media (min-width: 1280px){

.popover--new-jersey{
      left:calc(986 / 1118 * 100%);
      top:calc(236 / 691 * 100%)
  }
    }

.popover--north-carolina{
    left:calc(688 / 839 * 100%);
    top:calc(283 / 519 * 100%);
  }

@media (min-width: 1280px){

.popover--north-carolina{
      left:calc(932 / 1118 * 100%);
      top:calc(385 / 691 * 100%)
  }
    }

.popover--ohio{
    left:calc(613 / 839 * 100%);
    top:calc(196 / 519 * 100%);
  }

@media (min-width: 1280px){

.popover--ohio{
      left:calc(825 / 1118 * 100%);
      top:calc(266 / 691 * 100%)
  }
    }

.popover--pennsylvania{
    left:calc(683 / 839 * 100%);
    top:calc(171 / 519 * 100%);
  }

@media (min-width: 1280px){

.popover--pennsylvania{
      left:calc(922 / 1118 * 100%);
      top:calc(232 / 691 * 100%)
  }
    }

.popover--texas{
    left:calc(363 / 839 * 100%);
    top:calc(395 / 519 * 100%);
  }

@media (min-width: 1280px){

.popover--texas{
      left:calc(502 / 1118 * 100%);
      top:calc(545 / 691 * 100%)
  }
    }

.popover--virginia{
    left:calc(689 / 839 * 100%);
    top:calc(238 / 519 * 100%);
  }

@media (min-width: 1280px){

.popover--virginia{
      left:calc(922 / 1118 * 100%);
      top:calc(322 / 691 * 100%)
  }
    }

.menu-secondary{
  display:flex;
  align-items:center;
  gap:10px;
  color:white;
  font-family:var(--ff-bold);
}

.popover-btn{
  background-color:rgba(var(--outline-white), 0);
  color:var(--brand-dark-blue);
  cursor:pointer;
  display:block;
  height:30px;
  position:relative;
  width:30px;
}

.popover-btn,
  .popover-btn:before,
  .popover-btn:after{
    border-radius:50%;
  }

.popover-btn:before,
  .popover-btn:after{
    content:'';
    display:block;
    position:absolute;
    transition-duration:var(--transition-time) / 2;
    transition-property:transform;
  }

.popover-btn:before{
    background-color:var(--brand-light-blue);
    border:4px solid var(--brand-dark-blue);
    box-shadow:inset 0 0 0 2px var(--outline-white);
    content:'';
    height:100%;
    left:0;
    top:0;
    width:100%;
    z-index:2;
  }

.popover-btn:after{
    background-color:rgba(var(--brand-light-blue), 0.15);
    height:calc(100% + (8px * 2));
    left:50%;
    top:50%;
    transform:translate(-50%, -50%);
    width:calc(100% + (8px * 2));
    z-index:1;
  }

.popover-btn:hover:before{
      transform:scale(var(--popover-btn-scale));
    }

.popover-btn:hover:after{
      transform:translate(-50%, -50%) scale(var(--popover-btn-scale));
    }

.popover-btn .icon-minus,
  .popover-btn .icon-plus{
    color:var(--brand-dark-blue);
    height:10px;
    left:50%;
    pointer-events:none;
    position:absolute;
    top:50%;
    transform:translate(-50%, -50%);
    transition-duration:var(--transition-time) / 2;
    transition-property:color, opacity;
    width:10px;
    z-index:3;
  }

.md-no-js .popover-btn .icon-plus{
      opacity:0;
    }

.popover-btn .icon-minus{
    opacity:0;
  }

.md-no-js .popover-btn .icon-minus{
      opacity:1;
    }

.popover-btn outline-icon-baseline{
    position:absolute;
    top:50%;
    left:50%;
    transform:translate(-50%, -50%);
    z-index:4;
  }

.popover-btn--due-date,
  .popover-btn--history-chart{
    display:none;
    position:absolute;
  }

@media (min-width: 1024px){

.popover-btn--due-date,
  .popover-btn--history-chart{
      display:block
  }
    }

.popover-btn--is-active,
    .popover-btn .popover-btn--is-active{
      z-index:100;
      color:var(--brand-light-blue);
    }

.popover-btn--is-active:before{
      background-color:var(--brand-dark-blue);
    }
`;